const Categories = () => {
  const categories = [
    {
      icon: 'fas fa-baby',
      color: 'from-pink-500 to-purple-500',
      bgPattern: 'bg-pink-50',
      title: 'علّم ولدك',
      desc: 'نعلموا ولادكم من 3 لـ 6 سنين الحروف، الأرقام، الألوان والأشكال بطريقة مسلية وسهلة يفهموها',
      badge: '4 كتب متوفرة',
      available: true
    },
    {
      icon: 'fas fa-globe',
      color: 'from-blue-500 to-indigo-600',
      bgPattern: 'bg-blue-50',
      title: 'اللغات الأجنبية',
      desc: 'تعلم الإنجليزية، الفرنسية، الإسبانية والإيطالية في أسبوع واحد - كل حاجة مشروحة بالدارجة الجزائرية',
      badge: '4 كتب متوفرة',
      available: true
    },
    {
      icon: 'fas fa-briefcase',
      color: 'from-emerald-500 to-green-600',
      bgPattern: 'bg-emerald-50',
      title: 'الأعمال والريادة',
      desc: 'كيفاش تبدأ مشروعك وتستعمل التكنولوجيا باش تطور أعمالك في الجزائر - دلائل عملية وسهلة',
      badge: 'كتابان متوفران',
      available: true
    }
  ];

  return (
    <section className="relative z-10 py-24 bg-gradient-to-b from-white to-gray-50 overflow-x-hidden" id="categories">
      {/* Blue gradient blobs */}
      <div className="absolute top-10 right-10 w-48 h-48 md:w-64 md:h-64 lg:w-80 lg:h-80 bg-blue-500/15 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 bg-indigo-500/20 rounded-full blur-3xl"></div>
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-[800px] mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary rounded-full mb-6 font-semibold text-sm">
            <i className="fas fa-graduation-cap"></i>
            <span>الأقسام التعليمية</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-text mb-6 leading-tight">
            شوف واش راح تتعلم
          </h2>
          <p className="text-xl text-text2 leading-relaxed">
            محتوى واضح وسهل الفهم لكل المستويات - ابدأ رحلتك التعليمية درك!
          </p>
        </div>

        {/* Categories Grid */}
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {categories.map((cat, idx) => (
            <div
              key={idx}
              className={`group relative bg-white rounded-3xl overflow-hidden border-2 transition-all duration-300 ${
                cat.available 
                  ? 'border-gray-100 hover:border-primary hover:shadow-2xl hover:-translate-y-2 cursor-pointer' 
                  : 'border-gray-100 opacity-60'
              }`}
            >
              {/* Background Pattern */}
              <div className={`absolute top-0 right-0 w-48 h-48 ${cat.bgPattern} rounded-full -translate-y-1/2 translate-x-1/4 opacity-50 transition-transform duration-500 ${cat.available ? 'group-hover:scale-150' : ''}`}></div>
              
              <div className="relative p-6 md:p-8">
                {/* Icon */}
                <div className={`w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br ${cat.color} rounded-2xl flex items-center justify-center text-white text-xl md:text-2xl mb-4 md:mb-6 shadow-lg transform transition-transform duration-300 ${cat.available ? 'group-hover:scale-110 group-hover:rotate-3' : ''}`}>
                  <i className={cat.icon}></i>
                </div>

                {/* Badge */}
                <div className="mb-3 md:mb-4">
                  <span className={`inline-block text-xs font-bold px-3 py-1.5 rounded-lg ${
                    cat.available 
                      ? 'bg-primary/10 text-primary' 
                      : 'bg-gray-100 text-gray-500'
                  }`}>
                    {cat.badge}
                  </span>
                </div>

                {/* Title & Description */}
                <h3 className="text-xl md:text-2xl lg:text-3xl font-black text-text mb-3 md:mb-4">
                  {cat.title}
                </h3>
                <p className="text-base md:text-lg text-text2 leading-relaxed mb-4 md:mb-6">
                  {cat.desc}
                </p>

                {/* CTA */}
                {cat.available ? (
                  <a
                    href="/courses"
                    className="inline-flex items-center gap-2 text-primary font-bold group-hover:gap-3 transition-all"
                  >
                    <span>استكشف الآن</span>
                    <i className="fas fa-arrow-left"></i>
                  </a>
                ) : (
                  <div className="flex items-center gap-2 text-gray-400 font-bold">
                    <i className="fas fa-clock"></i>
                    <span>تحت التطوير</span>
                  </div>
                )}

                {/* Lock Icon for unavailable */}
                {!cat.available && (
                  <div className="absolute bottom-6 left-6 w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center text-gray-400">
                    <i className="fas fa-lock"></i>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Special CTA Card */}
        <div className="max-w-[1200px] mx-auto">
          <div className="relative bg-gradient-to-br from-primary via-primary-dark to-secondary rounded-3xl overflow-hidden p-10 md:p-12 shadow-2xl">
            {/* Animated Background */}
            <div className="absolute inset-0 opacity-20">
              <div className="absolute inset-0" style={{
                backgroundImage: `radial-gradient(circle at 20% 30%, rgba(255,255,255,0.3) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.2) 0%, transparent 50%)`
              }}></div>
            </div>

            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
              {/* Left Content */}
              <div className="flex-1 text-center md:text-right text-white">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-4 text-sm font-semibold">
                  <i className="fas fa-gift"></i>
                  <span>عرض خاص</span>
                </div>
                <h3 className="text-3xl md:text-4xl font-black mb-4 leading-tight">
                  ابدأ التعلم درك!
                </h3>
                <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-6">
                  سجل الآن واحصل على وصول مباشر للدورات - كل حاجة بالدارجة الجزائرية باش تفهم مليح!
                </p>
                <div className="flex items-center justify-center md:justify-start gap-4 text-sm">
                  <div className="flex items-center gap-2">
                    <i className="fas fa-check-circle"></i>
                    <span>تسجيل سريع</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="fas fa-check-circle"></i>
                    <span>محتوى حصري</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="fas fa-check-circle"></i>
                    <span>بالدارجة</span>
                  </div>
                </div>
              </div>

              {/* Right CTA */}
              <div className="flex-shrink-0">
                <a
                  href="/register"
                  className="group inline-flex items-center gap-3 px-10 py-5 bg-white text-primary font-black rounded-2xl hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1 text-lg"
                >
                  <span>سجل درك</span>
                  <i className="fas fa-arrow-left group-hover:-translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Categories;
